<div class="flex min-w-0 flex-auto flex-col">
  <!-- Main -->
  <div class="flex-auto p-6 sm:pt-10">
    <!-- CONTENT GOES HERE -->
    <div class="rounded-2xl">
      <!-- Main -->
      <div class="-mt-px flex-auto">
        <div class="w-full">
          <div
            class="grid w-full min-w-0 grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3"
          >
            <div class="flex flex-col flex-auto col-span-2 table-responsive">
              <mat-form-field
                class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded min-w-0 p-6 ml-6 mt-1"
              >
                <mat-icon
                  class="icon-size-5"
                  matPrefix
                  [svgIcon]="'heroicons_outline:magnifying-glass'"
                />

                <input
                  matInput
                  (keyup)="appliquerFiltre($event)"
                  [placeholder]="'Filtrer actifs'" 
                />
              </mat-form-field>
              <table
                mat-table
                [dataSource]="dataSource"
                class="mat-elevation-z8"
              >
                <!--- Note that these columns can be defined in any order.
                The actual rendered columns are set as a property on the row definition" -->

                <!-- Position Column 
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef>No.</th>
                <td mat-cell *matCellDef="let element">{{ element.position }}</td>
              </ng-container>-->

                <!-- Name Column -->
                <ng-container matColumnDef="Nom Actif">
                  <th mat-header-cell *matHeaderCellDef>Nom Actif</th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    style="cursor: pointer"
                    class="font-semibold hover:underline"
                  >
                    <a
                      [routerLink]="[
                        '/actifs',
                        element.referentiel.stockName,
                        element.referentiel.isin,
                      ]"
                      rel="noopener noreferrer"
                    >
                      {{ element.referentiel.stockName }}
                    </a>
                  </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="Cours">
                  <th mat-header-cell *matHeaderCellDef>Cours</th>
                  <td mat-cell *matCellDef="let element" class="pl-2">
                    {{ element.last | number: ".2-2" }}
                  </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="Variation">
                  <th mat-header-cell *matHeaderCellDef>Variation</th>
                  <td mat-cell *matCellDef="let element" class="pl-2">
                    <div
                      *ngIf="element.change >= 0"
                      style="color: rgb(22, 161, 22); font-weight: bold"
                    >
                      +{{ element.change | number: ".2-2" }}%
                    </div>
                    <div
                      *ngIf="element.change < 0"
                      style="color: rgb(237, 30, 30); font-weight: bold"
                    >
                      {{ element.change | number: ".2-2" }}%
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Ouverture">
                  <th mat-header-cell *matHeaderCellDef>Cloture Veille</th>
                  <td mat-cell *matCellDef="let element" class="pl-2">
                    {{ element.close | number: ".2-2" }}
                  </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="+ Haut">
                  <th mat-header-cell *matHeaderCellDef>+ Haut</th>
                  <td mat-cell *matCellDef="let element" class="pl-2">
                    {{ element.high | number: ".2-2" }}
                  </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="+ Bas">
                  <th mat-header-cell *matHeaderCellDef>+ Bas</th>
                  <td mat-cell *matCellDef="let element" class="pl-2">
                    {{ element.low | number: ".2-2" }}
                  </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="Titre">
                  <th mat-header-cell *matHeaderCellDef class="pl-3">
                    Volume (DT)
                  </th>
                  <td mat-cell *matCellDef="let element" class="pl-4">
                    {{ element.volume | number: "1.0-0" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="Volume">
                  <th mat-header-cell *matHeaderCellDef class="pl-4">Titres</th>
                  <td mat-cell *matCellDef="let element" class="pl-6">
                    {{ element.caps }}
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
            <div
              class="flex flex-col flex-auto col-span-1 overflow-hidden mt-6"
            >
              <div
                class="bg-card flex flex-col items-center max-w-100 max-h-65 sm:p-8 filter-post mb-6"
                style="background-color: #f0f0f0"
              >
                <button
                  (click)="redirectFormation()"
                  class="max w-50 p-2 rounded-lg font-medium bg-[#f4900c] text-[white]"
                >
                  Rejoignez notre formation
                </button>
                <img
                  src="assets/irbe7/illustration.webp"
                  class="max-h-50 w-full"
                  [alt]="'pavé'"
                />
                <p
                  class="max w-50 p-2 text-center font-medium"
                  style="color: #4524c8"
                >
                  Ressources et outils pour les investisseurs
                </p>
              </div>

              <table mat-table [dataSource]="dataSource1" class="mr-18 mb-6">
                <!-- Actif Column -->
                <ng-container matColumnDef="Indice">
                  <th mat-header-cell *matHeaderCellDef class="bg-indigo-100">
                    <div class="flex flex-row">
                      <p
                        class="ml-4 cursor-pointer p-3 pl-0 text-base font-semibold"
                      >
                        Indice
                      </p>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a
                      class="font-semibold hover:underline"
                      [routerLink]="[
                        '/actifs',
                        element.referentiel.stockName,
                        element.referentiel.isin,
                      ]"
                    >
                      {{ element.referentiel.stockName }}
                    </a>
                    <br />
                    <p class="font-light">
                      {{ element.referentiel.ticker }}
                    </p>
                  </td>
                </ng-container>

                <!-- Watchlist Column -->
                <ng-container matColumnDef="Valeur">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="cursor-pointer bg-indigo-100 p-3 text-base font-semibold"
                    (click)="afficherWatchlist()"
                  >
                    <p class="cursor-pointer p-3 pl-0 text-base font-semibold">
                      Valeur
                    </p>
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <p>
                      {{ element.last | number: ".2-2" }}
                    </p>
                    <p
                      *ngIf="element.change >= 0"
                      style="color: rgb(22, 161, 22)"
                    >
                      +{{ element.change | number: ".2-2" }}%
                    </p>
                    <p
                      *ngIf="element.change < 0"
                      style="color: rgb(237, 30, 30)"
                    >
                      {{ element.change | number: ".2-2" }}%
                    </p>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns1"
                ></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
